import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import styles from './App.module.css'
import { useAuth } from './app/authContext'
import { chromeFor, paths } from './app/routes'
import { AppHeader } from './components/chrome/AppHeader'
import { NetworkStrip } from './components/chrome/NetworkStrip'
import { RemoveModeOverlay } from './components/chrome/RemoveModeOverlay'
import { ToastProvider } from './components/feedback/ToastProvider'
import { useScanMode } from './app/scanModeContext'
import { useOnlineStatus } from './lib/useOnlineStatus'
import { useQueuedCount } from './outbox/useOutbox'
import { useOutboxSync } from './outbox/useSyncWorker'
import { ProductTour } from './components/feedback/ProductTour'

/** Only the pallet detail screen scans, so only it turns the frame red. */
const PALLET_DETAIL = /^\/pallets\/[^/]+$/

/**
 * One shell: header, screen outlet, network strip, and the overlays that sit above
 * everything. Screens never render chrome of their own.
 */
export default function App() {
  const location = useLocation()
  const navigate = useNavigate()
  const isOnline = useOnlineStatus()
  const { isAuthenticated } = useAuth()
  const queuedCount = useQueuedCount()
  const { mode } = useScanMode()
  useOutboxSync(isOnline, isAuthenticated)

  const chrome = chromeFor(location.pathname)
  const inRemoveMode = mode === 'remove' && PALLET_DETAIL.test(location.pathname)

  return (
    <div className={styles.shell}>
      {inRemoveMode && <RemoveModeOverlay />}

      {chrome.showChrome && (
        <AppHeader
          title={chrome.title}
          canGoBack={chrome.canGoBack}
          onBack={() => navigate(-1)}
          onSettings={() => navigate(paths.settings)}
        />
      )}

      {/*
        ToastProvider sits inside main so its toast positions against the screen body,
        which is where the artboard draws it — above the network strip, not over it.
      */}
      <main className={styles.body}>
        <ToastProvider>
          <Outlet />
        </ToastProvider>
      </main>

      {chrome.showChrome && <NetworkStrip isOnline={isOnline} queuedCount={queuedCount} />}
      {isAuthenticated && <ProductTour key={location.pathname} pathname={location.pathname} />}
    </div>
  )
}
